module.exports = __webpack_public_path__ + "static/dark-inventions-banner-34213df9edc5b45d98f633f32925983a.jpg";